import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import { getOrgInfo,getOrgList } from '@/api/api_url'
import Cookies from 'js-cookie'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */




// console.log(getOrgList(),"getOrgList()")
let hrefStr = location.href;

let orgData = '';
if (hrefStr.indexOf('localhost') >= 0) {
  orgData = getOrgInfo('education')  // ['business','education','dang','yunqi'] 本地切换机构在这里切换
} else {
  let typelist = getOrgList()
  for (var i in typelist) {
    orgData = getOrgInfo(typelist[i])
    if (hrefStr.indexOf(orgData.domain) >= 0) {
      orgData = getOrgInfo(typelist[i])
      break;
    }
  }
}






let orgTypeAdminRole = orgData.adminRole
let orgTypeClass = orgData.class
let orgTypeOfficeClass = orgData.officeClass
let orgTypemember = orgData.member

localStorage.setItem('orgType', JSON.stringify(orgData))


let listCookie=document.cookie.split(';');
let isClient='';
for(var i = 0; i < listCookie.length; i++) {
  var arr = listCookie[i].split("=");   // 解析出名和值
  if(arr[0].trim() == 'isClient'){
    console.log(arr[1],'qwe')
    isClient=arr[1]
  }
} 



 






var menuType = '1';
if (hrefStr.indexOf('classId') >= 0) {
  menuType = '2'
}

export const constantRoutes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/middle',
    component: () => import('@/views/login/middle'),
    hidden: true
  },
  {
    path: '/bind',
    component: () => import('@/views/login/bind'),
    hidden: true
  },


  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/dashboard',
    children: [{
      path: 'dashboard',
      name: '首页',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'dashboard', showSide: true }
    }]
  },

  {
    path: '/home',              // 办公，军校类首页
    component: Layout,
    redirect: '/home/home',
    children: [{
      path: 'home',
      name: '首页',
      component: () => import('@/views/dashboard/bg_home'),
      meta: { title: '首页', icon: 'dashboard', showSide: true }
    }]
  },

  {
    path: '/demo',
    component: Layout,
    redirect: '/demo/demo',
    children: [{
      path: 'demo',
      name: 'demo',
      component: () => import('@/views/dashboard/demo'),
      meta: { title: 'demo', icon: 'dashboard', showSide: true }
    }]
  },

  {
    path: '/client/examination',
    component: Layout,
    redirect: '/client/examination',
    hidden: true,
    children: [{
      path: '/client/examination',
      name: '评测',
      component: () => import('@/views/client/examination'),
      meta: { title: '评测', icon: 'dashboard' }
    }]
  },

  {
    path: '/client/homework',
    hidden: true,
    component: Layout,
    redirect: '/client/homework',
    children: [{
      path: '/client/homework',
      name: '作业',
      component: () => import('@/views/client/homework'),
      meta: { title: '作业', icon: 'dashboard' }
    }]
  },
  // {
  //   path: '/homework',
  //   component: Layout,
  //   redirect: '/dashboard/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: '首页',
  //     component: () => import('@/views/dashboard/index'),
  //     meta: { title: '首页', icon: 'dashboard' }
  //   }]
  // },

  // {
  //   path: '/client',
  //   component: Layout,
  //   // redirect: '/client/examination',
  //   name: '列表',
  //   meta: { title: '列表', icon: 'el-icon-edit' },
  //   hidden:true,
  //   children: [
  //     {
  //       path: '/client/examination',
  //       name: '评测',
  //       component: () => import('@/views/client/examination'),
  //       meta: { title: '评测', icon: 'el-icon-edit' },
  //       hidden:true
  //     },
  //     {
  //       path: '/client/homework',
  //       name: '作业',
  //       component: () => import('@/views/client/homework'),
  //       meta: { title: '作业', icon: 'table' },
  //       hidden: true
  //     },
  //   ]
  // },



  // 新加的页面


  {
    path: '/classnote',
    component: Layout,
    redirect: '/classnote/index',
    name: '课堂笔记',
    meta: { title: '课堂笔记', icon: 'el-icon-c-scale-to-original' },
    children: [
      {
        path: '/classnote/index',
        name: '课堂笔记',
        component: () => import('@/views/classnote/index'),
        meta: { title: '课堂笔记', icon: 'el-icon-edit', showSide: true },
      },
      {
        path: '/classnote/user/:noteId',
        name: '学生列表',
        component: () => import('@/views/classnote/classnote_user'),
        meta: { title: '学生列表', icon: 'el-icon-edit', activeMenu: '/classnote/index', showSide: true },
      },
      {
        path: '/classnote/detail/:noteId/user/:userId',
        name: '学生笔记',
        component: () => import('@/views/classnote/classnote_detail'),
        meta: { title: '学生笔记', icon: 'el-icon-edit', activeMenu: '/classnote/index', showSide: true },
      }
    ]
  },

  {
    path: '/homework',
    component: Layout,
    redirect: '/homework/homeworkList',
    name: '作业',
    meta: { title: '作业', icon: 'el-icon-edit' },
    children: [
      {
        path: '/homework/homeworkList',
        name: '作业',
        component: () => import('@/views/homework/homeworkList/index'),
        meta: { title: '作业', icon: 'el-icon-edit', showSide: true },
      },
      {
        path: '/homework/created',
        name: '作业发布',
        component: () => import('@/views/homework/created/index'),
        meta: { title: '作业发布', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },
        hidden: true
      },
      {
        path: '/homework/downloadWork',
        name: '创建评测完成',
        component: () => import('@/views/homework/downloadWork/index'),
        meta: { title: '创建评测完成', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },
        hidden: true
      },
      {
        path: '/homework/correct',
        name: '作业批改',
        component: () => import('@/views/homework/correct/index'),
        meta: { title: '作业批改', icon: 'table', activeMenu: '/homework/homeworkList', showSide: false },
        hidden: true
      },
      {
        path: '/homework/end',
        name: '结束批改',
        component: () => import('@/views/homework/correct/end'),
        meta: { title: '结束批改', icon: 'table', showSide: false },
        hidden: true
      },
      {
        path: '/homework/homeworkDetail',
        name: '作业详情',
        component: () => import('@/views/homework/homeworkDetail/index'),
        meta: { title: '作业详情', icon: 'table', activeMenu: '/homework/homeworkList', showSide: !isClient?true:false },

        hidden: true
      },


      {
        path: '/homework/compareGrade',
        name: '年级整体对比统计',
        component: () => import('@/views/homework/homeworkDetail/compareGrade'),
        meta: { title: '年级整体对比统计', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },

        hidden: true
      },
      {
        path: '/homework/compareGradeSingel',
        name: '年级单题对比统计',
        component: () => import('@/views/homework/homeworkDetail/compareGradeSingel'),
        meta: { title: '年级单题对比统计', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },

        hidden: true
      },
      {
        path: '/homework/studentScore',
        name: '学生成绩详情',
        component: () => import('@/views/homework/homeworkDetail/studentScore'),
        meta: { title: '学生成绩详情', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },

        hidden: true
      },

      {
        path: '/homework/homeworkanalysis',
        name: '作业单题分析',
        component: () => import('@/views/homework/homeworkanalysis/index'),
        meta: { title: '作业单题分析', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },
        hidden: true
      },
      {
        path: '/homework/analysisReportHome',
        name: '分析报告',
        component: () => import('@/views/homework/analysisReportHome/index'),
        meta: { title: '分析报告', icon: 'table', activeMenu: '/homework/homeworkList', showSide: true },
        hidden: true
      },
      {
        path: '/homework/homeworkSingle',
        name: '单个学生作业报告',
        component: () => import('@/views/homework/single/index'),
        meta: { title: '单个学生作业报告', icon: 'table', activeMenu: '/homework/homeworkList', showSide: false },
        hidden: true
      },


    ]
  },



  {
    path: '/test',
    component: Layout,
    redirect: '/test/test',
    name: '评测',
    meta: { title: '评测', icon: 'el-icon-finished' },
    children: [
      {
        path: 'test',
        name: '评测',
        component: () => import('@/views/test/examlist/index'),
        meta: { title: '评测', icon: 'el-icon-finished', showSide: true }
      },
      {
        path: '/test/created',
        name: '创建评测',
        component: () => import('@/views/test/created/index'),
        meta: { title: '创建评测', icon: 'table', activeMenu: '/test/test', showSide: true },
        hidden: true
      },
      {
        path: '/test/downloadExam',
        name: '创建评测完成',
        component: () => import('@/views/test/downloadExam/index'),
        meta: { title: '创建评测完成', icon: 'table', activeMenu: '/test/test', showSide: true },
        hidden: true
      },
      {
        path: '/test/examdetail',
        name: '评测详情',
        component: () => import('@/views/test/examdetail/index'),
        meta: { title: '评测详情', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },
        hidden: true
      },
      {
        path: '/test/compareGrade',
        name: '年级整体对比统计',
        component: () => import('@/views/test/examdetail/compareGrade'),
        meta: { title: '年级整体对比统计', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },

        hidden: true
      },
      {
        path: '/test/compareGradeSingel',
        name: '年级单题对比统计',
        component: () => import('@/views/test/examdetail/compareGradeSingel'),
        meta: { title: '年级单题对比统计', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },

        hidden: true
      },
      {
        path: '/test/studentScore',
        name: '学生成绩详情',
        component: () => import('@/views/test/examdetail/studentScore'),
        meta: { title: '学生成绩详情', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },

        hidden: true
      },
      {
        path: '/test/examanalysis',
        name: '评测单题分析',
        component: () => import('@/views/test/examanalysis/index'),
        meta: { title: '评测单题分析', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },
        hidden: true
      },
      {
        path: '/test/correct',
        name: '评测批改',
        component: () => import('@/views/test/correct/index'),
        meta: { title: '评测批改', icon: 'table', activeMenu: '/test/test', showSide: false },
        hidden: true
      },
      {
        path: '/test/end',
        name: '结束批改',
        component: () => import('@/views/test/correct/end'),
        meta: { title: '结束批改', icon: 'table', activeMenu: '/test/test', showSide: false },
        hidden: true
      },
      {
        path: '/test/report',
        name: '学生总体报告',
        component: () => import('@/views/test/report/index'),
        meta: { title: '学生总体报告', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },
        hidden: true
      },
      {
        path: '/test/analysisReport',
        name: '分析报告',
        component: () => import('@/views/test/analysisReport/index'),
        meta: { title: '分析报告', icon: 'table', activeMenu: '/test/test', showSide: !isClient?true:false },
        hidden: true
      },
      {
        path: '/test/single',
        name: '单个学生评测报告',
        component: () => import('@/views/test/single/index'),
        meta: { title: '单个学生评测报告', icon: 'table', activeMenu: '/test/test', showSide: false },
        hidden: true
      },
    ]
  },






  {
    path: '/viewReport',
    component: Layout,
    redirect: '/viewReport/viewReport',
    name: '评测',
    meta: { title: '评测', icon: 'report2' },
    children: [
      {
        path: '/viewReport/viewclassHomework',
        name: '班级作业',
        component: () => import('@/views/viewReport/viewclassHomework/index'),
        meta: { icon: 'classRp3', showSide: true },

      },
      {
        path: '/viewReport/viewclassReport',
        name: '班级评测',
        component: () => import('@/views/viewReport/viewclassReport/index'),
        meta: { title: '班级评测', icon: 'class22', showSide: true },

      },
      {
        path: '/viewReport/viewReport',
        name: '学员评测',
        component: () => import('@/views/viewReport/index'),
        meta: { title: '学员评测', icon: 'student2', showSide: true }
      },
      {
        path: '/viewReport/viewStudentReport',
        name: '详情报告',
        component: () => import('@/views/viewReport/viewStudentReport/index'),
        meta: { title: '详情报告', icon: 'student2', showSide: true, activeMenu: '/viewReport/viewReport' }
      },
      {
        path: '/viewReport/viewtestReport',
        name: '学生评测报告',
        component: () => import('@/views/viewReport/viewtestReport/index'),
        meta: { title: '学生评测报告', icon: 'table', activeMenu: '/viewReport/viewReport', showSide: true },
        hidden: true
      },
      {
        path: '/viewReport/viewhomeReport',
        name: '学生作业报告',
        component: () => import('@/views/viewReport/viewhomeReport/index'),
        meta: { title: '学生作业报告', icon: 'table', activeMenu: '/viewReport/viewReport', showSide: true },
        hidden: true
      },
      {
        path: '/viewReport/wrongTopic/userId/:userId/:userName',
        name: '错题本',
        component: () => import('@/views/viewReport/wrongTopicList'),
        meta: { title: '错题本', icon: 'table', activeMenu: '/viewReport/viewReport', showSide: true },
        hidden: true
      },

      {
        path: '/viewReport/interact',
        name: '互动评估',
        component: () => import('@/views/viewReport/interact'),
        meta: { title: '互动评估', icon: 'interact2', activeMenu: '/viewReport/interact', showSide: true },

      },
      {
        path: '/viewReport/taskReport',
        name: '作业报告',
        component: () => import('@/views/viewReport/taskReport'),
        meta: { title: '作业报告', icon: 'task_report', activeMenu: '/viewReport/taskReport', showSide: true },
      },
      {
        path: '/viewReport/teacherReport',
        name: '教师报告',
        component: () => import('@/views/viewReport/teacherReport'),
        meta: { title: '教师报告', icon: 'teacher_report', activeMenu: '/viewReport/teacherReport', showSide: true },
      },
      {
        path: '/viewReport/teacherOneReport',
        name: '教师报告',
        component: () => import('@/views/viewReport/teacherOneReport'),
        meta: { title: '教师报告', icon: 'teacher_report', activeMenu: '/viewReport/teacherReport', showSide: true },
      }
    ]
  },



  {
    path: '/resource',
    component: Layout,
    redirect: '/resource/resource',
    name: '文档库',
    meta: { title: '文档库', icon: 'el-icon-folder-opened' },
    children: [
      {
        path: 'resource',
        name: '文档库',
        component: () => import('@/views/resource/doc_source/index'),
        meta: { title: '文档库', icon: 'el-icon-folder-opened', showSide: true }
      },
      {
        path: '/resource/answer',
        name: '推送答案',
        component: () => import('@/views/resource/answer/index'),
        meta: { title: '推送答案', icon: 'table', activeMenu: '/resource/resource', showSide: true },
        hidden: true
      },
      {
        path: '/resource/source1',
        name: '上传文档 一',
        component: () => import('@/views/resource/source1/index'),
        meta: { title: '上传文档 一', icon: 'table', activeMenu: '/resource/resource', showSide: true },
        hidden: true
      },
      {
        path: '/resource/createNote',
        name: '上传文档 一',
        component: () => import('@/views/resource/source1/createNote'),
        meta: { title: '上传文档 一', icon: 'table', activeMenu: '/resource/resource', showSide: true },
        hidden: true
      },
      {
        path: '/resource/drawTopic',
        name: '制卷划题',
        component: () => import('@/views/resource/drawTopic/index'),
        meta: { title: '制卷划题', icon: 'table', activeMenu: '/resource/resource', },
        hidden: true
      },
      {
        path: '/resource/source1_system',
        name: '上传文档 一',
        component: () => import('@/views/resource/source1_system/index'),
        meta: { title: '上传文档 一(系统标引)', icon: 'table', activeMenu: '/resource/resource', showSide: true },
        hidden: true
      },
      {
        path: '/resource/source2',
        name: '上传文档 二',
        component: () => import('@/views/resource/source2/index'),
        meta: { title: '上传文档 二', icon: 'table', activeMenu: '/resource/resource', showSide: false },
        hidden: true
      },

      {
        path: '/resource/source3',
        name: '上传文档 三',
        component: () => import('@/views/resource/source3/index'),
        meta: { title: '上传文档 三', icon: 'table', activeMenu: '/resource/resource', showSide: true },
        hidden: true
      },
    ]
  },


  {
    path: '/wrong_question_book',
    component: Layout,
    redirect: '/wrong_question_book/wrong_question_book',
    name: '错题本',
    meta: { title: '错题本', icon: 'el-icon-document-delete' },
    children: [
      {
        path: 'wrong_question_book',
        name: '错题本',
        component: () => import('@/views/wrongQuestionList/index'),
        meta: { title: '错题本', icon: 'el-icon-document-delete',activeMenu: '/wrong_question_book', showSide: true }
      },
      
     
    ]
  },


  {
    path: '/MicroClass',
    component: Layout,
    // redirect: '/MicroClass/MicroClass',
    name: '微录课',
    // meta: { title: '微录课', icon: 'el-icon-video-camera-solid' },
    children: [
      {
        path: '/MicroClass/MicroClassList',
        name: '微录课',
        component: () => import('@/views/Micro/index'),
        meta: { title: '微录课', icon: 'el-icon-video-camera-solid', showSide: true }
      },
      {
        path: '/MicroClass/statistics',
        name: '微录课统计',
        component: () => import('@/views/Micro/welesson_statistics'),
        meta: { title: '微录课', icon: 'el-icon-video-camera-solid', showSide: true }
      },


    ]
  },
  {
    path: '/setTestPaper',
    component: Layout,
    // redirect: '/MicroClass/MicroClass',
    name: '同步组卷',
    // meta: { title: '微录课', icon: 'el-icon-video-camera-solid' },
    children: [
      {
        path: '/setTestPaper/setTestPaper',
        name: '同步组卷',
        component: () => import('@/views/setTestPaper/index'),
        meta: { title: '同步组卷', icon: 'el-icon-video-camera-solid', showSide: true }
      },
      {
        path: '/setTestPaper/edit',
        name: '同步组卷-编辑',
        component: () => import('@/views/setTestPaper/edit'),
        meta: { title: '同步组卷-编辑', icon: 'el-icon-video-camera-solid', showSide: false, },
        hidden: true
      },
      {
        path: '/setTestPaper/add',
        name: '同步组卷-新增',
        component: () => import('@/views/setTestPaper/add'),
        meta: { title: '同步组卷-新增', icon: 'el-icon-video-camera-solid', showSide: false, },
        hidden: true
      },



    ]
  },



  {
    path: '/noted',
    component: Layout,
    redirect: '/noted/notedInfo',
    name: '行政办公',
    meta: { title: '行政办公', icon: 'el-icon-collection' },
    children: [
      {
        path: 'notedInfo',
        name: '数据采集',
        component: () => import('@/views/noted/notedInfo/index'),
        meta: { title: '数据采集', icon: 'el-icon-edit-outline', showSide: true }
      },
      {
        path: 'notedInfo/armyGroup',
        name: '分组查看',
        component: () => import('@/views/noted/notedInfo/armyGroup'),
        meta: { title: '分组查看', icon: 'el-icon-edit-outline', showSide: true, activeMenu: '/noted/notedInfo' }
      },
      {
        path: 'notedInfo/:id',
        name: '数据采集',
        component: () => import('@/views/noted/notedInfo/index'),
        meta: { title: '数据采集', icon: 'el-icon-edit-outline', showSide: true }
      },

      {
        path: 'noted',
        name: '笔记本',
        component: () => import('@/views/noted/notedBooks/index'),
        meta: { title: '笔记本', icon: 'el-icon-notebook-1', showSide: true }
      },

      {
        path: '/notedInfo/noted1',
        name: '创建记录-1',
        component: () => import('@/views/noted/noted1/index'),
        meta: { title: '创建记录-1', icon: 'table', activeMenu: menuType == '1' ? '/noted/notedInfo' : '/resource/resource', showSide: true },
        hidden: true
      },

      {
        path: '/notedInfo/noted1/:id',
        name: '创建记录-1',
        component: () => import('@/views/noted/noted1/index'),
        meta: { title: '创建记录-1', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },



      {
        path: '/notedInfo/noted2',
        name: '创建记录-2',
        component: () => import('@/views/noted/noted2/index'),
        meta: { title: '创建记录-2', icon: 'table', keepAlive: true, activeMenu: '/noted/notedInfo', showSide: false },
        hidden: true
      },
      {
        path: '/notedInfo/markNote',
        name: '创建记录-2',
        component: () => import('@/views/noted/noted2/markNote'),
        meta: { title: '创建记录-2', icon: 'table', keepAlive: true, activeMenu: '/resource/resource', showSide: false },
        hidden: true
      },


      {
        path: '/notedInfo/noted2/:id',
        name: '创建记录-2',
        component: () => import('@/views/noted/noted2/index'),
        meta: { title: '创建记录-2', icon: 'table', keepAlive: true, activeMenu: 'notedInfo/:id', showSide: false },
        hidden: true
      },

      {
        path: '/notedInfo/noted3',
        name: '创建记录-3',
        component: () => import('@/views/noted/noted3/index'),
        meta: { title: '创建笔记录-3', icon: 'table', activeMenu: '/resource/resource', showSide: true },
        hidden: true
      },

      {
        path: '/notedInfo/noted3/:id',
        name: '创建记录-3',
        component: () => import('@/views/noted/noted3/index'),
        meta: { title: '创建笔记录-3', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },



      {
        path: '/notedInfo/dataInfo',
        name: '数据(列表)',
        component: () => import('@/views/noted/dataInfo/index'),
        meta: { title: '数据(列表)', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfo/:id',
        name: '数据(列表)',
        component: () => import('@/views/noted/dataInfo/index'),
        meta: { title: '数据(列表)', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoCheck',
        name: '数据-校对',
        component: () => import('@/views/noted/dataInfoCheck/index'),
        meta: { title: '数据-校对', icon: 'table', activeMenu: 'fhxy', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoCheck/:id',
        name: '数据-校对',
        component: () => import('@/views/noted/dataInfoCheck/index'),
        meta: { title: '数据-校对', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/noteEnd',
        name: '数据-校对',
        component: () => import('@/views/noted/dataInfoCheck/end'),
        meta: { title: '数据-校对', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/noteEnd/:id',
        name: '数据-校对',
        component: () => import('@/views/noted/dataInfoCheck/end'),
        meta: { title: '数据-校对', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/previewNote',
        name: '数据-浏览',
        component: () => import('@/views/noted/dataInfoCheck/previewNote'),
        meta: { title: '数据-浏览', icon: 'table', activeMenu: '/viewReport/viewReport', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/previewNoteForClass',
        name: '数据-浏览',
        component: () => import('@/views/noted/dataInfoCheck/previewNoteForClass'),
        meta: { title: '数据-浏览', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/previewNoteForPerson',
        name: '数据-浏览',
        component: () => import('@/views/noted/dataInfoCheck/previewNoteForPerson'),
        meta: { title: '数据-浏览', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoStat',
        name: '数据-统计',
        component: () => import('@/views/noted/dataInfoStat/index'),
        meta: { title: '数据-统计', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoStat/custom',
        name: '自定义统计界面',
        component: () => import('@/views/noted/dataInfoStat/custom'),
        meta: { title: '自定义统计界面', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoStat/:id',
        name: '数据-统计',
        component: () => import('@/views/noted/dataInfoStat/index'),
        meta: { title: '数据-统计', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoTiled',
        name: '数据(平铺)',
        component: () => import('@/views/noted/tiled/index'),
        meta: { title: '数据(平铺)', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/dataInfoTiled/:id',
        name: '数据(平铺)',
        component: () => import('@/views/noted/tiled/index'),
        meta: { title: '数据(平铺)', icon: 'table', activeMenu: '/noted/notedInfo/:id', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/noteUser/:noteId/template_id/:templateId',
        name: '笔记用户',
        component: () => import('@/views/noted/noteUser/index'),
        meta: { title: '笔记用户', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/notePage/:noteId/userId/:userId',
        name: '用户笔记',
        component: () => import('@/views/noted/noteUser/notePage'),
        meta: { title: '用户笔记', icon: 'table', activeMenu:'fhxy', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/personNotePage',
        name: '笔记本数据',
        component: () => import('@/views/noted/noteUser/personNotePage'),
        meta: { title: '笔记本数据', icon: 'table', activeMenu: '/viewReport/viewReport', showSide: true },
        hidden: true
      },
      {
        path: '/notedInfo/custom_field',
        name: '自定义字段',
        component: () => import('@/views/noted/dataInfo/custom_field'),
        meta: { title: '自定义字段', icon: 'table', activeMenu: '/noted/notedInfo', showSide: true },
        hidden: true
      }
      



    ]
  },



  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'Nested',
  //   meta: {
  //     title: 'Nested',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: { title: 'Menu1' },
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'Menu1-1',
  //           meta: { title: 'Menu1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           meta: { title: 'Menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: { title: 'Menu1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'Menu1-2-2',
  //               meta: { title: 'Menu1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'Menu1-3',
  //           meta: { title: 'Menu1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       name: 'Menu2',
  //       meta: { title: 'menu2' }
  //     }
  //   ]
  // },





  {
    path: '/report_forms',
    component: Layout,
    redirect: '/report_forms/index',
    name: '报表',
    meta: { title: '报表', icon: 'el-icon-data-analysis' },
    children: [
      {
        path: '/report_forms/index/:sTime?/:eTime?',
        name: '报表',
        component: () => import('@/views/report_forms/index'),
        meta: { title: '报表', icon: 'el-icon-c-scale-to-original',activeMenu: '/report_forms', showSide: true }
      },
      {
        path: '/report_forms/clockIn/:userId/:sTime?/:eTime?',
        name: '打卡详情',
        component: () => import('@/views/report_forms/user_clockin'),
        meta: { title: '打卡详情', icon: 'el-icon-map-location',activeMenu: '/report_forms', showSide: true },
      },
      {
        path: '/report_forms/subData/:userId/:sTime?/:eTime?',
        name: '提交详情',
        component: () => import('@/views/report_forms/user_submit'),
        meta: { title: '提交详情', icon: 'el-icon-receiving',activeMenu: '/report_forms', showSide: true },
      },
      {
        path: '/report_forms/indexPerson',
        name: '个人统计',
        component: () => import('@/views/report_forms/indexPerson'),
        meta: { title: '个人统计', icon: 'el-icon-s-data',activeMenu: '/report_forms', showSide: true },
      },
    ]
  },

  {
    path: '/warning',
    component: Layout,
    redirect: '/warning/index',
    name: '预警',
    meta: { title: '预警', icon: 'el-icon-chat-dot-square' },
    children: [
      {
        path: '/warning/index',
        name: '预警统计',
        component: () => import('@/views/warning/index'),
        meta: { title: '预警统计', icon: 'el-icon-c-scale-to-original', showSide: true }
      },
      {
        path: '/warning/warning_flow',
        name: '流程管理',
        component: () => import('@/views/warning/warning_flow'),
        meta: { title: '流程管理', icon: 'el-icon-map-location', showSide: true }
      },
      {
        path: '/warning/add_warning_flow',
        name: '新增流程',
        component: () => import('@/views/warning/add_warning_flow'),
        meta: { title: '新增流程', icon: 'el-icon-receiving', showSide: true }
      },
    ]
  },

  {
    path: '/photos',
    component: Layout,
    redirect: '/photos/index',
    name: '拍照',
    meta: { title: '拍照', icon: 'el-icon-camera' },
    children: [
      {
        path: '/photos/index',
        name: '数据浏览',
        component: () => import('@/views/photos/index'),
        meta: { title: '数据浏览', icon: 'el-icon-camera', showSide: true }
      },

    ]
  },

  // 新增的 军队查看评教、评学类页面

  // 我的数据 菜单
  {
    path: '/evaluate/userid',
    component: Layout,
    redirect: '/evaluate/userid',
    children: [{
      path: '/evaluate/userid',
      name: '我的数据',
      component: () => import('@/views/onlyStudentPage/userid'),
      meta: { title: '我的数据', icon: 'el-icon-s-custom', activeMenu: '/evaluate/userid', showSide: true }
    }]
  },
  // 评教评学 菜单
  {
    path: '/evaluate/ratee',
    component: Layout,
    redirect: '/evaluate/ratee',
    children: [{
      path: '/evaluate/ratee',
      name: '评教评学',
      component: () => import('@/views/onlyStudentPage/ratee'),
      meta: { title: '评教评学', icon: 'el-icon-notebook-1', activeMenu: '/evaluate/ratee', showSide: true }
    }]
  },
  

  {
    path: '/onlyStudentPage',
    component: Layout,
    redirect: '/onlyStudentPage/index',
    name: '单独的学生登录查看',
    meta: { title: '单独的学生登录查看', icon: 'el-icon-collection' },
    children: [
      {
        path: '/onlyStudentPage/index',
        name: '单独的学生登录查看',
        component: () => import('@/views/onlyStudentPage/index'),
        meta: { title: '单独的学生登录查看', icon: 'el-icon-collection', activeMenu: '/noted/notedInfo', showSide: true }
      },
      {
        path: '/onlyStudentPage/index/mine',
        name: '单独的学生登录查看',
        component: () => import('@/views/onlyStudentPage/index'),
        meta: { title: '单独的学生登录查看', icon: 'el-icon-collection', activeMenu: '/noted/notedInfo', showSide: true }
      },
      {
        path: '/onlyStudentPage/index/teacher',
        name: '评教',
        component: () => import('@/views/onlyStudentPage/index'),
        meta: { title: '评教', icon: 'el-icon-collection', activeMenu: '/onlyStudentPage/index/teacher', showSide: true }
      },
      {
        path: '/onlyStudentPage/index/student',
        name: '评学',
        component: () => import('@/views/onlyStudentPage/index'),
        meta: { title: '评学', icon: 'el-icon-collection', activeMenu: '/onlyStudentPage/index/student', showSide: true }
      },

    ]
  },

  // 教研室
  // {
  //   path: '/office',
  //   component: Layout,
  //   redirect: '/office/index',
  //   name:'教研室',
  //   meta: { title: '教研室', icon: 'el-icon-office-building' },
  //   children: [
  //     {
  //       path: '/office/index',
  //       name: '教研室',
  //       component: () => import('@/views/manage/office/index'),
  //       meta: { title: '教研室', icon: 'el-icon-office-building',showSide:true }
  //     },
  //     {
  //       path: '/office/detail',
  //       component: () => import('@/views/manage/office/datail/index'), // Parent router-view
  //       name: orgTypeOfficeClass+'详情',
  //       meta: { title: orgTypeOfficeClass + '详情', icon: 'nested', activeMenu: '/office/index',showSide:true },
  //       hidden: true


  //     },
  //     {
  //       path: '/office/create',
  //       component: () => import('@/views/manage/office/create/index'), // Parent router-view
  //       name: '添加学生',
  //       meta: { title: '添加' + orgTypemember, icon: 'nested', activeMenu: '/office/index',showSide:true },
  //       hidden: true
  //     },
  //     {
  //       path: '/office/edit',
  //       component: () => import('@/views/manage/office/edit/index'), // Parent router-view
  //       name: '编辑学生',
  //       meta: { title: '编辑' + orgTypemember, icon: 'nested', activeMenu: '/office/index',showSide:true },
  //       hidden: true
  //     },

  //   ]
  // },






  {
    path: '/manage',
    component: Layout,
    redirect: '/manage/teacher',
    name: '管理',
    meta: {
      title: '管理',
      icon: 'el-icon-set-up'
    },


    children: [
      {
        path: 'teacher',
        component: () => import('@/views/manage/teacher/index'), // Parent router-view
        name: '教师',
        // meta: { title: orgTypeAdminRole=="老师"?'教师':"老师", icon: 'teacher',showSide:true },
        meta: { title: orgTypeAdminRole, icon: 'teacher', showSide: true },
        // children:[
        //   {
        //     path: 'created',
        //     component: () => import('@/views/manage/created/index'), // Parent router-view
        //     name: '添加教师',
        //     meta: { title: '添加' + orgTypeAdminRole, icon: 'nested',activeMenu: '/manage/teacher'},
        //     hidden: true
        //   },
        //   {
        //     path: 'edit',
        //     component: () => import('@/views/manage/edit/index'), // Parent router-view
        //     name: '编辑教师',
        //     meta: { title:'编辑' + orgTypeAdminRole, icon: 'nested', activeMenu: '/manage/teacher', },
        //     hidden: true


        //   },
        // ]
      },


      {
        path: 'created',
        component: () => import('@/views/manage/created/index'), // Parent router-view
        name: '添加教师',
        meta: { title: '添加' + orgTypeAdminRole, icon: 'nested', activeMenu: '/manage/teacher', showSide: true },
        hidden: true


      },
      {
        path: 'edit',
        component: () => import('@/views/manage/edit/index'), // Parent router-view
        name: '编辑教师',
        meta: { title: '编辑' + orgTypeAdminRole, icon: 'nested', activeMenu: '/manage/teacher', showSide: true },
        hidden: true


      },

      {
        path: 'class',
        component: () => import('@/views/manage/class/index'), // Parent router-view
        name: '班级',
        meta: { title: orgTypeClass, icon: 'class2', showSide: true },


      },




      {
        path: 'class/detail',
        component: () => import('@/views/manage/class/datail/index'), // Parent router-view
        name: '班级详情',
        meta: { title: orgTypeClass + '详情', icon: 'nested', activeMenu: '/manage/class', showSide: true },
        hidden: true


      },
      {
        path: 'class/create',
        component: () => import('@/views/manage/class/create/index'), // Parent router-view
        name: '添加学生',
        meta: { title: '添加' + orgTypemember, icon: 'nested', activeMenu: '/manage/class', showSide: true },
        hidden: true
      },
      {
        path: 'class/edit',
        component: () => import('@/views/manage/class/edit/index'), // Parent router-view
        name: '编辑学生',
        meta: { title: '编辑' + orgTypemember, icon: 'nested', activeMenu: '/manage/class', showSide: true },
        hidden: true
      },

      // 教研室


      {
        path: '/office/index',
        name: '教研室',
        component: () => import('@/views/manage/office/index'),
        meta: { title: '教研室', icon: 'el-icon-office-building', showSide: true }
      },
      {
        path: '/office/detail',
        component: () => import('@/views/manage/office/datail/index'), // Parent router-view
        name: orgTypeOfficeClass + '详情',
        meta: { title: orgTypeOfficeClass + '详情', icon: 'nested', activeMenu: '/office/index', showSide: true },
        hidden: true


      },
      {
        path: '/office/create',
        component: () => import('@/views/manage/office/create/index'), // Parent router-view
        name: '添加学生',
        meta: { title: '添加' + orgTypemember, icon: 'nested', activeMenu: '/office/index', showSide: true },
        hidden: true
      },
      {
        path: '/office/edit',
        component: () => import('@/views/manage/office/edit/index'), // Parent router-view
        name: '编辑学生',
        meta: { title: '编辑' + orgTypemember, icon: 'nested', activeMenu: '/office/index', showSide: true },
        hidden: true
      },

      {
        path: 'subject',
        component: () => import('@/views/manage/subject//index'), // Parent router-view
        name: '学科',
        meta: { title: '学科', icon: 'subject', showSide: true },


      },
      {
        path: 'setup',
        component: () => import('@/views/manage/setup//index'), // Parent router-view
        name: '设置',
        meta: { title: '设置', icon: 'subject', showSide: true },


      },
      {
        path: 'devices',
        component: () => import('@/views/manage/devices//index'), // Parent router-view
        name: '设备',
        meta: { title: '设备', icon: 'el-icon-setting', showSide: true },

      },
      {
        path: 'devices/create',
        component: () => import('@/views/manage/devices/create/index'), // Parent router-view
        name: '设备',
        meta: { title: '设备', icon: 'device', activeMenu: '/manage/devices', showSide: true },
        hidden: true
      },
      {
        path: 'locating_point',
        component: () => import('@/views/manage/locating_point//index'),
        name: '定位点',
        meta: { title: '定位点', icon: 'el-icon-place', showSide: true }
      },
      {
        path: 'locating_detail/:locatingId',
        component: () => import('@/views/manage/locating_point/locating_detail'),
        name: '打卡详情',
        meta: { title: '打卡详情', icon: 'el-icon-place', showSide: true }
      },
      {
        path: 'dict',
        component: () => import('@/views/manage/dict/index'), // Parent router-view
        name: '字典',
        meta: { title: '字典', icon: 'el-icon-notebook-2', showSide: true },
      },
      {
        path: 'dict/dictDetail',
        component: () => import('@/views/manage/dict/detail'), // Parent router-view
        name: '字典详情',
        meta: { title: '字典详情', icon: 'el-icon-notebook-2', showSide: true, activeMenu: '/manage/dict', },
        hidden: true


      },
      {
        path: 'note_sort',
        component: () => import('@/views/manage/dict/note_sort'), // Parent router-view
        name: '笔记分类',
        meta: { title: '笔记分类', icon: 'el-icon-menu', showSide: true, activeMenu: '/manage/note_sort', },
        hidden: true


      },

      {
        path: 'group',
        component: () => import('@/views/manage/group/index'), // Parent router-view
        name: '区队',
        meta: { title: '区队', icon: 'el-icon-s-flag', showSide: true },


      },
      {
        path: 'group/groupDetail',
        component: () => import('@/views/manage/group/detail'), // Parent router-view
        name: '区队详情',
        meta: { title: '区队详情', icon: 'el-icon-notebook-2', showSide: true, activeMenu: '/manage/group', },
        hidden: true


      },

      {
        path: 'personInfo',
        component: () => import('@/views/manage/personInfo//index'), // Parent router-view
        name: '个人信息',
        meta: { title: '个人信息', icon: 'user', showSide: true },
        hidden: true

      },
      {
        path: 'operLog',
        component: () => import('@/views/manage/operLog//index'), // Parent router-view
        name: '操作日志',
        meta: { title: '操作日志', icon: 'operator', showSide: true },
        hidden: true

      },
      {
        path: 'admin',
        component: () => import('@/views/manage/admin//index'), // Parent router-view
        name: '管理员',
        meta: { title: '管理员', icon: 'admin', showSide: true },
        hidden: true

      },
      {
        path: 'audio_record',
        component: () => import('@/views/manage/audio_record//audio_test'),
        meta: { title: '录音', icon: 'el-icon-folder-opened', showSide: true },
        hidden: true
      },

    ]
  },

  // // 测试答题卡生成
  // {
  //   path: '/answer_sheet/:type?',
  //   component: () => import('@/views/answer_sheet/index'),
  //   meta: { title: '答题卡', icon: 'el-icon-folder-opened',showSide:true },
  //   hidden: true
  // },
  // 测试答题卡生成 （这种都是没有没有侧边栏和顶部的页面）
  {
    path: '/answer_sheet_add/:templateId/resource_id/:resourceId/:type?',
    component: () => import('@/views/resource/answer_sheet/card_add'),
    meta: { title: '答题卡', icon: 'el-icon-folder-opened', showSide: true },
    hidden: true
  },
  {
    path: '/testPage/:resourceId',
    component: () => import('@/views/answer_sheet/testPage'),
    meta: { title: '答题卡', icon: 'el-icon-folder-opened', showSide: true },
    hidden: true
  },
  {
    path: '/dataBoard',
    name: '学校看板',
    component: () => import('@/views/data_board/index'),
    meta: { title: '学校看板', icon: 'data_board', showSide: true },
  },
  // // word 上传提取题干
  // {
  //   path: '/word_card/',
  //   component: () => import('@/views/answer_sheet/word_card'),
  //   meta: { title: 'word上传', icon: 'el-icon-folder-opened',showSide:true },
  //   hidden: true
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]





const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
router.beforeEach((to, from, next) => {
  // console.log(333)
  if (to.path === '/middle' || to.path === '/login'||to.path === '/bind') {
    next();
  } else {
    let token = '';
    if (localStorage.getItem('Authorization') && localStorage.getItem('Authorization') != 'undefined') {
      token = localStorage.getItem('Authorization');
    } else {
      token = Cookies.get('Authorization')
    }

    // alert(token);
    if (!token || token == 'undefined') {
      next('/login');
    } else {
      next()
      // let sidebarStr = localStorage.getItem('sidebarList')
      // if(sidebarStr){
      //   let routesArr = JSON.parse(sidebarStr)
      //   toPath = routesArr[0].uri
      // }
      // next(toPath)
    }

    // if (token =='null' || token == '') {

    //   alert('kong')

    // } 
  }
});


// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
